import { Component, OnInit } from '@angular/core';
import text from '../../assets/textos.json';
import {DomSanitizer,SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

  pageText;
  // carouselsUrls = [];
  constructor(public sanitizer:DomSanitizer) 
  {
    this.pageText = text;
    // for (let index = 0; index < this.pageText["modulo1"].multimedia.length; index++)
    // {
    //   let secureUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pageText["modulo1"].multimedia[index].url);
    //   console.log(secureUrl);
    //   this.carouselsUrls.push(secureUrl["changingThisBreaksApplicationSecurity"]);     
      
    // }
    // console.log(this.carouselsUrls);
  }
  
  ngOnInit() {
  }

  slideConfig = {
    "slidesToShow": 1, 
    "slidesToScroll": 1,
    "autoplay": false,
    "dots":true,
    "infinite": false,  
    "arrows": false,
    "lazyLoad": 'ondemand'
  };
  
  slickInit(e) {
    console.log('slick initialized');
  }
  
  breakpoint(e) {
    console.log('breakpoint');
  }
  
  afterChange(e) {
    console.log('afterChange');
  }
  
  beforeChange(e) {
    console.log('beforeChange');
  }
  
}
